import {
  SAVE_STACKUP_FULFILLED,
  INIT_STACKUP,
  RESTORE_STACKUP
} from '../../actions/action-types';

const initialState = "";

function name(state = initialState, action){
  switch(action.type){
    case SAVE_STACKUP_FULFILLED:
      return action.payload.name;
    case INIT_STACKUP:
      return action.payload.name;
    case RESTORE_STACKUP:
      return action.payload.name;
    default:
      return state;
  }
}

export function getName(state) {
  return state;
}

export default name;



// WEBPACK FOOTER //
// ./src/reducers/stackup/name.js